import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchPendingRequests = createAsyncThunk(
  "tourrequest/all-pending-request",
  async () => {
    const response = await fetch(
      "https://joyfulserver.ddns.net:443/api/TourRequest/all-pending-requests"
    );
    const result = await response.json();
    return result.data;
  }
);

export const fetchContactedRequests = createAsyncThunk(
  "tourrequest/all-contacted-request",
  async () => {
    const response = await fetch(
      "https://joyfulserver.ddns.net:443/api/TourRequest/all-contacted-requests"
    );
    const result = await response.json();
    return result.data;
  }
);
export const changeStatus = createAsyncThunk(
  "features/change-status",
  async (tourRequestId,adminEmail) => {
    const response = await fetch(
      `https://joyfulserver.ddns.net:443/api/TourRequest/change-status`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(tourRequestId,adminEmail),
      }
    );
    return await response.json();
  }
);


export const addRequest = createAsyncThunk(
  "features/add-request",
  async ({ name, email, phone ,tourId}) => {
    const response = await fetch(
      `https://joyfulserver.ddns.net:443/api/TourRequest/add-request`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, phone ,tourId}),
      }
    );
    return await response.json();
  }
);

export const deleteRequest = createAsyncThunk(
  "features/delete-request",
  async (tourRequestId) => {
    const response = await fetch(
      `https://joyfulserver.ddns.net:443/api/TourRequest/delete-request`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(tourRequestId),
      }
    );
    return await response.json();
  }
);

const requestsSlice = createSlice({
  name: "requests",
  initialState: {
    requests:[],
    pendingRequests: [],
    contactedRequests:[],
    length:0,
    status: "idle",
    error: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchPendingRequests.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPendingRequests.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.pendingRequests = action.payload;
      })
      .addCase(fetchPendingRequests.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(fetchContactedRequests.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchContactedRequests.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.contactedRequests = action.payload;
      })
      .addCase(fetchContactedRequests.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(addRequest.fulfilled, (state, action) => {
        if (action.payload && action.payload.name) {
          state.pendingRequests.push(action.payload);
          state.length = state.pendingRequests.length;
        }
      })

      .addCase(changeStatus.fulfilled, (state, action) => {
        if (action.payload && action.payload.name) {
          var request = state.pendingRequests.find((pr)=>pr.id === action.payload);
          console.log(request);
          state.pendingRequests = state.pendingRequests.filter(pr=>pr.id !== action.payload);
          state.contactedRequests.push(request);
        }
      })
  },
});

export default requestsSlice.reducer;
